import { render, staticRenderFns } from "./PermissionGrey.vue?vue&type=template&id=65c97e18&"
import script from "./PermissionGrey.vue?vue&type=script&lang=js&"
export * from "./PermissionGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports